module.exports = __webpack_public_path__ + "public/img/pm.270f6349.png";